<template>
  <div>
    <table>
      <tr>
        <td>
          <div style="float: left">
            <h1>{{ translateWords.RackManage }}</h1>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="200px"
            class="demo-ruleForm"
          >
            <table>
              <tr>
                <td>
                  <el-form-item :label="translateWords.RackNo" prop="RackNo">
                    <el-input v-model="ruleForm.RackNo"></el-input
                  ></el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item :label="translateWords.Code" prop="Code">
                    <el-input
                      :disabled="true"
                      :placeholder="translateWords.autoProdut"
                      v-model="ruleForm.Code"
                      style="width: 400px"
                    ></el-input
                  ></el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item
                    :label="translateWords.PositionId"
                    prop="PositionId"
                  >
                    <el-select
                      v-model="ruleForm.PositionId"
                      :placeholder="translateWords.select"
                      filterable
                      style="width: 400px"
                    >
                      <el-option
                        v-for="item in PositionIdoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item
                    :label="translateWords.IsUseRackLayer"
                    prop="IsUseRackLayer"
                    style="width: 300px"
                  >
                    <el-select
                      v-model="ruleForm.IsUseRackLayer"
                      :placeholder="translateWords.select"
                      filterable
                      @change="selectvalue(ruleForm.IsUseRackLayer)"
                    >
                      <el-option
                        v-for="item in IsUseRackLayeroptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr v-if="isshowlayer">
                <td>
                  <el-form-item :label="translateWords.LayerNo" prop="LayerNo">
                    <el-input
                      placeholder=""
                      v-model="ruleForm.LayerNo"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr v-if="isshowlayer">
                <td>
                  <el-form-item :label="translateWords.SubCode" prop="SubCode">
                    <el-input
                      :placeholder="translateWords.autoProdut"
                      :disabled="true"
                      v-model="ruleForm.SubCode"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item
                    :label="translateWords.RackStatus"
                    prop="IsUseRack"
                    style="width: 300px"
                  >
                    <el-select
                      v-model="ruleForm.IsUseRack"
                      filterable
                      :placeholder="translateWords.select"
                    >
                      <el-option
                        v-for="item in IsUseRackoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item :label="translateWords.Remark" prop="Remark">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder=""
                      v-model="ruleForm.Remark"
                    >
                    </el-input
                  ></el-form-item>
                </td>
              </tr>
            </table>
            <el-form-item style="float: left">
              <el-button type="primary" @click="submitForm('ruleForm')">{{
                translateWords.save
              }}</el-button>
            </el-form-item>
          </el-form>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { importScript } from "../util/importScript";
export default {
  name: "AddRack",
  props: ["PositionIdoptions"],
  data() {
    return {
      translateWords: {
        RackManage: "货架管理",
        RackNo: "货架号",
        Code: "货架主码",
        PositionId: "位置",
        select: "请选择",
        IsUseRackLayer: "货架层状态",
        autoProdut: "自动生成",
        LayerNo: "货架层",
        SubCode: "货架层子码",
        RackStatus: "货架状态",
        Remark: "备注",
        save: "保存",
        roomBelong: "请输入归属房间",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
      },
      ruleForm: {
        PositionId: 0,
        Code: "",
        RackNo: "",
        LayerNo: "",
        SubCode: "",
        IsUseRackLayer: 1,
        IsUseRack: 1,
        Remark: "",
      },
      rules: {
        RackNo: [{ required: true, message: "货架号不能为空" }],
        PositionId: [{ required: true, message: "请选择一个房间" }],
        IsUseRackLayer: [{ required: true, message: "请选择货架层状态" }],
        IsUseRack: [{ required: true, message: "请选择货架状态" }],
        LayerNo: [{ required: true, message: "货架层不能为空" }],
      },
      uid: this.$route.query.uid,
      lang: this.$route.query.lang,
      token: this.$route.query.token,
      isshowlayer: true,
      IsUseRackLayeroptions: [],
      IsUseRackoptions: [],
      IsEdit: "0",
      rowjson: '',
    };
  },
  created: function () {
    // this.IsUseRackLayeroptions=this.$store.getters.getinitstatus;
    // this.IsUseRackoptions=this.$store.getters.getinitstatus;
    this.getinitstatus();
  },

  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.translateWord();
    });
  },
  methods: {
    translateWord() {
      var that = this;

      if (window.jsT) {
        this.translateWords = {
          RackManage: window.jsT.T(that.translateWords.RackManage),
          RackNo: window.jsT.T(that.translateWords.RackNo),
          Code: window.jsT.T(that.translateWords.Code),
          PositionId: window.jsT.T(that.translateWords.PositionId),

          select: window.jsT.T(that.translateWords.select),
          IsUseRackLayer: window.jsT.T(that.translateWords.IsUseRackLayer),
          autoProdut: window.jsT.T(that.translateWords.autoProdut),
          LayerNo: window.jsT.T(that.translateWords.LayerNo),

          SubCode: window.jsT.T(that.translateWords.SubCode),
          RackStatus: window.jsT.T(that.translateWords.RackStatus),
          Remark: window.jsT.T(that.translateWords.Remark),
          save: window.jsT.T(that.translateWords.save),
          saveSuccess: window.jsT.T(that.translateWords.saveSuccess),
          saveFail: window.jsT.T(that.translateWords.saveFail),
        };
        // this.ruleForm.IsUseRackLayer = window.jsT.T(that.ruleForm.IsUseRackLayer);
        //this.ruleForm.IsUseRack = window.jsT.T(that.ruleForm.IsUseRack);

        this.rules = {
          RackNo: [{ required: true, message: window.jsT.T("货架号不能为空") }],
          PositionId: [
            { required: true, message: window.jsT.T("请选择一个房间") },
          ],
          IsUseRackLayer: [
            { required: true, message: window.jsT.T("请选择货架层状态") },
          ],
          IsUseRack: [
            { required: true, message: window.jsT.T("请选择货架状态") },
          ],
          LayerNo: [
            { required: true, message: window.jsT.T("货架层不能为空") },
          ],
        };
      } else {
        console.log("翻译组件加载失败");
      }
    },
    init() {
      this.$refs["ruleForm"].resetFields();
      this.rowjson='';
    },
    setvalue(rowjson) {
         //this.isEdit=status;
         this.rowjson=rowjson;
         var obj=JSON.parse(rowjson)
         this.ruleForm.PositionId=obj.PositionId;
         this.ruleForm.RackNo=obj.RackNo;
         this.ruleForm.Code=obj.Code;
         this.ruleForm.IsUseRackLayer=obj.IsUseRackLayerCode;
         this.ruleForm.IsUseRack=obj.IsUseRackCode;
          this.ruleForm.LayerNo=obj.LayerNo;
          this.ruleForm.SubCode=obj.SubCode;
           this.ruleForm.Remark=obj.Remark;
    },
    getinitstatus() {
      var params = new URLSearchParams();
      params.append("cmd", "GetStatus");
      params.append("lang", this.lang);
      this.$http.post(this.actionurl, params).then((res) => {
        this.IsUseRackoptions = res.data.Data;
        this.IsUseRackLayeroptions = res.data.Data;
      });
    },
    selectvalue(val) {
      if (val == 2) this.isshowlayer = false;
      else this.isshowlayer = true;
    },
    submitForm(formName) {
      var that = this;
   
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.PositionId == "" || this.ruleForm.PositionId == 0) {
            alert(that.translateWords.roomBelong);
            return;
          }
          var params = new URLSearchParams();
          for (var key in this.ruleForm) {
            params.append(key, this.ruleForm[key]);
          }
          params.append("lang", this.lang);
          params.append("uid", this.uid);
          if(this.rowjson=='')
          params.append("cmd", "SaveSample_Rack");
          else
          {  //params.append("rowjson", JSON.stringify(this.ruleForm));
            var obj=  JSON.parse(this.rowjson);
            params.append("Id",obj.Id);
             params.append("cmd", "EditSampleRack");
          }
          this.$http.post(this.actionurl, params).then((res) => {
            if (res.data.Message == "") {
              alert(that.translateWords.saveSuccess);

              this.$emit("closedialog");
            } else {
              alert(that.translateWords.saveFail + "," + res.data.Message);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AddRack.vue